import { LanguageService } from "../services/languages";

// Shown under the name of a company marked "closed" in the admin
const CLOSED_LABEL = {
  en: 'closed at this moment',
  hy: 'Այս պահին փակ է',
  ru: 'В данный момент закрыто',
};

export const getClosedLabel = () => CLOSED_LABEL[LanguageService.getLanguageCode()] || CLOSED_LABEL.en;
